module.exports = __webpack_public_path__ + "img/index-vod.46a5ed42.png";